import styles from './AgentLabel.module.css'

type Props = {
  isVisible?: boolean
  disableOnClick?: boolean
  onClick?: () => void
  agentName?: string
}

export const AgentLabel = ({ agentName, isVisible = true, disableOnClick = false, onClick = () => {} }: Props) => {
  if (!isVisible) {
    return null
  }

  let text = `Akira is now using ${agentName} mode.`
  if (!disableOnClick) {
    text += ` Click here to close the Agent`
  }

  const className = disableOnClick ? styles.readOnlyAgentlabel : styles.agentlabel

  const onClickLabel = () => {
    if (!disableOnClick) {
      onClick()
    }
  }

  return (
    <legend onClick={onClickLabel}>
      <span className={className}>{text}</span>
    </legend>
  )
}
